module.exports = __webpack_public_path__ + "img/quotes-dot.a4f39bb8.svg";